import React from 'react'

export default function PercentageComponent({ percentage, colorScheme = 'default' }) {
  const schemes = {
    default: [
      { max: 39, color: '#df4040d9' },
      { max: 69, color: '#FFD700' },
      { max: 100, color: '#00BA97' }
    ],
    inverse: [
      { max: 39, color: '#00BA97' },
      { max: 69, color: '#FFD700' },
      { max: 100, color: '#df4040d9' }
    ]
  }

  const getColor = value => schemes[colorScheme].find(c => value <= c.max).color

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: getColor(percentage),
        fontFamily: 'Satoshi',
        fontSize: 18,
        width: 66,
        fontWeight: 500,
        borderRadius: 8,
        padding: '1px 0'
      }}
    >
      {percentage}%
    </div>
  )
}
